import { ControlledSelectOption } from "ui";

export enum AppAccessEnum {
  active = "active",
  disabled = "disabled",
}

export const appAccessEnumValues = Object.values(AppAccessEnum);

export const appAccessEnumLabelMap: Record<AppAccessEnum, string> = {
  [AppAccessEnum.active]: "Active",
  [AppAccessEnum.disabled]: "Inactive",
};

export const appAccessEnumSelectOptions: ControlledSelectOption[] = [
  {
    label: "Enabled",
    value: AppAccessEnum.active,
  },
  {
    label: "Disabled",
    value: AppAccessEnum.disabled,
  },
];
